<template>
  <div />
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters("oidc", ["oidcUser"]),
    ...mapState(["empleadoDatos", "profile"]),
    idEmpleado() {
      /* if(this.empleadoDatos.Id_Empleado == '0') {
            return null
        }
        else{ */
      return this.empleadoDatos.Id_Empleado;
      /* } */
    },
    esExterno() {
      return this.profile.Es_Externo;
    },
  },
  watch: {
    idEmpleado: {
      handler(newValue, oldValue) {
        //if(newValue != null) {
        this.validarAcceso();
        //}
      },
    },
    esExterno: {
      handler(newValue, oldValue) {
        //if(newValue != null) {
        this.validarAcceso();
        //}
      },
    },
  },
  beforeMount() {
    //console.log(this.oidcUser);
    /*   if (this.oidcUser.Id_Empleado == "") {
      this.$router.push({ name: "misServiciosExterno" });
    } else {
      this.$router.push({ name: "inicioAdministrador" });
    } */
    //   if (this.state.oidc.user.Id_Empleado === "") {
  },
  mounted() {
    if (this.esExterno == true) {
      this.validarAcceso();
    }
  },
  methods: {
    ...mapActions(["tienePermisoServicio"]),
    async validarAcceso() {
      if (this.empleadoDatos.Id_Empleado != "00000") {
        this.$router.push({ name: "inicioAdministrador" });
      } else {
        this.$router.push({ name: "misServiciosExterno" });
      }
    },
  },
};
</script>
